var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('log-table',{attrs:{"datetime-range":_vm.datetimeRange,"columns":_vm.columns,"get-func":_vm.getFunc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }